<template>
  <router-view />
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      //
    }
  },
  mounted() {
    this.scrollToTop();
  },
  created() {
    //
    this.fetchSettings();
  },
  methods: {
    scrollToTop() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    //
    fetchSettings() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + '/settings',
        method: 'GET',
        headers: {
          appId: window.appID
        },
        data: {}
      }
      this.axios(options)
        .then(res => {
          const phone = res.data.data.country_code + res.data.data.mobile;

          localStorage.setItem('settings.phone', phone);
          localStorage.setItem('settings.logo', res.data.data.image.url);
          localStorage.setItem('settings.email', res.data.data.email);
          localStorage.setItem('settings.en.address', res.data.data.en.address);
          localStorage.setItem('settings.ar.address', res.data.data.ar.address);

          window.$("img.logo").attr("src", res.data.data.image.url);
          document.title = this.$i18n.locale == "ar" ? res.data.data.ar.title : res.data.data.en.title;
          document
            .getElementsByName("description")[0]
            .setAttribute("content", this.$i18n.locale == "ar" ? res.data.data.ar.body : res.data.data.en.body);

          let link = document.getElementsByName("favicon.ico")[0];
          if (!link) {
            link = document.createElement("link");
            link.setAttribute("rel", "icon");
            document.getElementsByTagName("head")[0].appendChild(link);
          }
          link.setAttribute("href", res.data.data.favicon.url);

          //logo
          window.$(".phone-link").attr("href", 'tel:' + phone);
          window.$(".phone-link").attr("data-phone", phone);
          window.$(".phone-link").append(`
               ${phone}
          `);
          window.$(".contact-phone-link").html(`
               ${phone}
          `);
          window.$(".address-setting").html(this.$i18n.locale == "ar" ? res.data.data.ar.address : res.data.data.en.address);
          window.$(".bio-setting").html(this.$i18n.locale == "ar" ? res.data.data.ar.title : res.data.data.en.title);
          window.$(".email-setting").html(res.data.data.email);
          window.$(".email-setting").attr("href", 'mailto:' + res.data.data.email);

        })
        .catch(() => {
        })
        .finally(() => {
        });
    },
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.hidden {
  display: none;
}
</style>
